<template>
  <v-menu bottom left offset-y :disabled="disabled">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="ml-4" icon v-bind="attrs" v-on="on" small>
        <v-icon>mdi-dots-horizontal</v-icon>
      </v-btn>
    </template>
    <v-list dense class="my-0 py-0">
      <v-list-item
        :disabled="payment.default"
        @click="changeDefaultPayment(payment)"
      >
        <v-list-item-title>
          {{ $t('message.pages.userPlan.makeDefault') }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        :disabled="payment.default || payment.type === 'boleto'"
        @click="handleDeleteCard(payment)"
      >
        <v-list-item-title>
          <span
            :class="
              payment.default || payment.type === 'boleto' ? '' : 'error--text'
            "
          >
            {{ $t('message.actions.remove') }}
          </span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'PaymentMethodOptions',
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    payment: {
      required: true,
    },
  },
  methods: {
    changeDefaultPayment(payment) {
      this.$emit('changeDefaultPayment', payment)
    },
    handleDeleteCard(payment) {
      this.$emit('handleDeleteCard', payment)
    },
  },
}
</script>
